module.exports = __webpack_public_path__ + "img/06.4d15f38f.svg";